import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=6b4b239e"
import script from "./SubmitOrder.vue?vue&type=script&lang=js"
export * from "./SubmitOrder.vue?vue&type=script&lang=js"
import style0 from "./SubmitOrder.vue?vue&type=style&index=0&id=6b4b239e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports